var _dec, _dec2, _class, _TreeButton;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { testable } from '@instructure/ui-testable';
import { Img } from '@instructure/ui-img';
import { callRenderProp } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import generateStyles from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';
import TreeBrowserContext from '../TreeBrowserContext';

// Todo: merge TreeButton and TreeNode: TreeButton should be a special type of TreeNode

/**
---
parent: TreeBrowser
id: TreeBrowser.Button
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let TreeButton = (_dec = withStyle(generateStyles, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_TreeButton = class TreeButton extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      if (el && typeof this.props.containerRef === 'function') {
        this.props.containerRef(el.parentElement);
      }
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props, _this$context;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, {
      animation: (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.animation
    });
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2, _this$context2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, {
      animation: (_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.animation
    });
  }
  defaultContentRenderer(props) {
    const name = props.name,
      descriptor = props.descriptor,
      styles = props.styles;
    return _jsxs("span", {
      css: styles.layout,
      children: [this.renderImage(), _jsxs("span", {
        css: styles.text,
        children: [_jsx("span", {
          css: styles.textName,
          children: name
        }), descriptor ? _jsx("span", {
          css: styles.textDescriptor,
          title: descriptor,
          children: descriptor
        }) : null]
      })]
    });
  }
  renderImage() {
    const type = this.props.type;
    switch (type) {
      case 'collection':
        return this.renderCollectionIcon();
      case 'item':
        return this.renderItemImage();
      default:
        break;
    }
    return void 0;
  }
  renderCollectionIcon() {
    const _this$props3 = this.props,
      expanded = _this$props3.expanded,
      collectionIcon = _this$props3.collectionIcon,
      collectionIconExpanded = _this$props3.collectionIconExpanded,
      styles = _this$props3.styles;
    if (collectionIcon || collectionIconExpanded) {
      return _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.icon,
        children: callRenderProp(expanded ? collectionIconExpanded : collectionIcon)
      });
    }
    return void 0;
  }
  renderItemImage() {
    const _this$props4 = this.props,
      thumbnail = _this$props4.thumbnail,
      itemIcon = _this$props4.itemIcon,
      styles = _this$props4.styles;
    if (thumbnail) {
      return _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.thumbnail,
        children: _jsx(Img, {
          src: thumbnail,
          constrain: "cover",
          alt: ""
        })
      });
    }
    if (itemIcon) {
      return _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.icon,
        children: callRenderProp(itemIcon)
      });
    }
    return void 0;
  }
  render() {
    const _this$props5 = this.props,
      styles = _this$props5.styles,
      renderContent = _this$props5.renderContent;
    const buttonContent = renderContent ? renderContent(this.props) : this.defaultContentRenderer(this.props);
    // VoiceOver can't navigate without the buttons, even though they don't do anything
    return _jsx("button", {
      ref: this.handleRef,
      tabIndex: -1,
      type: "button",
      css: styles === null || styles === void 0 ? void 0 : styles.treeButton,
      children: buttonContent
    });
  }
}, _TreeButton.displayName = "TreeButton", _TreeButton.componentId = 'TreeBrowser.Button', _TreeButton.allowedProps = allowedProps, _TreeButton.propTypes = propTypes, _TreeButton.contextType = TreeBrowserContext, _TreeButton.defaultProps = {
  type: 'treeButton',
  size: 'medium',
  variant: 'folderTree',
  selected: false,
  focused: false,
  expanded: false
}, _TreeButton)) || _class) || _class);
export default TreeButton;
export { TreeButton };